import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import QRCode from "react-qr-code";
import Common from '../Common/common';

const BookingCategory = (props) => {
  const { settings } = props;
  const [categoryList, setCategoryMaster] = useState([]);
  const [shoplist, setShoplist] = useState([]);
  const [selectCategory, setSelectCategory] = useState({ category_id: '', category_name: '' });
  const [selectShop, setSelectShop] = useState(props.user.shopId);
  const [selectDisabled, setSelectdisabled] = useState(true);
  const refreshData = useCallback(async () => {
    const jwt = localStorage.getItem('jwt');
    const categoryPromise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/category/listall`, { site_id: props.siteId }, { headers: { Authorization: `Bearer ${jwt}` } });
    const category = (await categoryPromise).data;
    setCategoryMaster(category);
    
    if(selectShop === null){
      const setshop = shoplist.reduce( (prev,curr) => (prev.shop_id < curr.shop_id) ? prev : curr)
      setSelectShop(setshop)
    }
    //selectShop
    //setSelectShop
  }, [props.siteId, selectShop, shoplist]);

  const getShoplist = useCallback(async () => {
    //支所一覧を取得
    const jwt = localStorage.getItem('jwt');
    const result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/shop/search`, { site_id: props.siteId, operator: "and", where: [{ site_id: props.siteId }] }, { headers: { Authorization: `Bearer ${jwt}` } });
    await setShoplist(result.data);
    //ユーザー権限確認
    if (props.user.userClass === '1') {
      await setSelectdisabled(false);
    }
  }, [props.siteId, props.user.userClass])

  useEffect(() => {
      getShoplist();
    }, [getShoplist]);
  useEffect(() => {
    refreshData();
  }, [refreshData]);
  const changeCategory = (value) => {
    if (value === '') {
      setSelectCategory({ category_id: '', category_name: '' })
    } else {
      const select = categoryList.find(x => x.category_id === Number(value));
      setSelectCategory(select)
    }
  }
  const changeSelectShop = (date => {
    //店舗選択
    setSelectShop(date.target.value);
  })

  const renderList = () => {
    return (selectShop != null &&
      <div>
        <div className='row'>
            <div className="col-2 text-center"><h5>カテゴリー</h5></div>
            <select className="col-4 custom-select text-center" aria-label="カテゴリ"
              value={selectCategory.category_id}
              onChange={(e) => changeCategory(e.target.value)}>
              <option value="">- 選択 -</option>
              {categoryList.map((item) =>
                <option key={item.category_id} value={item.category_id}>{item.category_name}</option>
              )}
            </select>
            <div className="col-2 text-center"><h5>支所</h5></div>
            <select className="col-4 custom-select text-center" aria-label="支所"
              value={selectShop}
              onChange={changeSelectShop}
              disabled={selectDisabled}
            >
              {shoplist.map((item, idx) =>
                <option key={idx} value={item.shop_id}>{item.shop_name}</option>
              )}
            </select>
        </div>
        <div className='row'>
          <div className='col text-center p-3'>
            {selectCategory.category_id !== '' && <QRCode value={`${Common.getSettingValue(settings, "API_LIFF_URL", '')}/?page=receptqr&cd=${selectCategory.category_id}&sp=${selectShop}`} />}
          </div>

        </div>
      </div>
    );
  }
  return (
    <div className="container">
      {(categoryList.length > 0) && renderList()}
    </div>
  )
}

export default BookingCategory;
